import { LocalStorage } from 'quasar';
import AuthService from 'src/lib/api/authentication.service';
import constants from 'src/lib/constants';
import api from 'src/lib/api/client';
import jwtDecode from 'jwt-decode';

export async function authenticate({ commit, dispatch }, { email, password }) {
  const response = await AuthService.authenticate({ email, password });
  if (response.status === 200 && response.data?.account) {
    const { account, bearerToken } = response.data;

    commit('application/updateAccount', { account }, { root: true });
    commit('application/updateToken', { accessToken: bearerToken }, { root: true });
    await dispatch('storeCredentials', { token: bearerToken });

    api.axiosConfigDefaults.headers.Authorization = `Bearer ${bearerToken}`;
    await api.init();
  }
}

export async function logout({ commit }) {
  await LocalStorage.remove(constants.LOCALSTORAGE_BEARER_TOKEN);
  delete api.axiosConfigDefaults.headers.Authorization;
  await api.init();

  commit('application/updateToken', { accessToken: null }, { root: true });
  commit('application/updateAccount', { account: null }, { root: true });

  commit('accounts/flush', {}, { root: true });
}

export async function renewToken({ commit, dispatch }, { token }) {
  commit('application/updateToken', { accessToken: token }, { root: true });
  api.axiosConfigDefaults.headers.Authorization = `Bearer ${token}`;
  await api.init();

  const response = await AuthService.renewToken();
  if (response.status === 200 && response.data?.token) {
    commit('application/updateToken', { accessToken: response.data.token }, { root: true });

    api.axiosConfigDefaults.headers.Authorization = `Bearer ${response.data.token}`;
    await api.init();
    await dispatch('storeCredentials', { token: response.data.token });
  }
  else {
    await dispatch('logout');
  }
}

export async function storeCredentials(context, { token }) {
  LocalStorage.set(constants.LOCALSTORAGE_BEARER_TOKEN, token);
}

export async function loadCredentials({ commit, dispatch }) {
  if (LocalStorage.has(constants.LOCALSTORAGE_BEARER_TOKEN)) {
    let token = LocalStorage.getItem(constants.LOCALSTORAGE_BEARER_TOKEN);
    let decodedToken = jwtDecode(token);

    if (parseInt(decodedToken.exp, 10) < parseInt(Date.now() / 1000, 10)) {
      // Token is expired, lets renew
      await dispatch('renewToken', { token });
    }

    // Token is renewed / valid and we continue
    if (LocalStorage.has(constants.LOCALSTORAGE_BEARER_TOKEN)) {
      token = LocalStorage.getItem(constants.LOCALSTORAGE_BEARER_TOKEN);
      decodedToken = jwtDecode(token);

      api.axiosConfigDefaults.headers.Authorization = `Bearer ${token}`;
      await api.init();

      commit('application/updateToken', { accessToken: token }, { root: true });

      const account = await dispatch('accounts/getAccount', { id: decodedToken.account }, { root: true });

      if (account) {
        commit('application/updateAccount', { account }, { root: true });
      }
    }
  }
}
